import { styled } from "@mui/system";
import Button, { ButtonProps } from "@mui/material/Button";
import { ArrowDropDown, ArrowForward, OpenInNew } from "@mui/icons-material";
import { Theme } from "@mui/material";
import React from "react";

interface MenuButtonProps extends ButtonProps {
  label: string;
  icon: React.ElementType;
}

export const MenuButton = styled(
  ({ label, icon: IconComponent, ...props }: MenuButtonProps) => {
    return (
      <Button {...props}>
        {IconComponent && <IconComponent />} {/* Renders the provided icon */}
        {label}
        <ArrowDropDown />
      </Button>
    );
  }
)(({ theme: Theme }) => ({
  fontWeight: "bold",
  display: "flex",
  alignItems: "center",
  gap: "8px", // Adds spacing between elements
}));

export const NeonButton = styled(Button)(({ theme: Theme }) => ({
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
    height:'36.5px',
    paddingLeft: 12,
    paddingRight: 12,
}))

// Button for internal navigation (within the same website)
export const NeonButtonInnerNavigation = styled(Button)(({ theme: Theme }) => ({
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
    height:'36.5px',
    paddingLeft:0,
    paddingRight:0,
    '& .MuiButton-endIcon': {
        marginLeft: '4px',
    }
})) as typeof Button & {
    (props: ButtonProps & { endIcon?: React.ReactElement }): React.ReactElement;
};

// Button for external navigation (to another website)
export const NeonButtonOuterNavigation = styled(Button)(({ theme: Theme }) => ({
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
    height:'36.5px',
    paddingLeft:0,
    paddingRight:0,
    '& .MuiButton-endIcon': {
        marginLeft: '4px',
    }
})) as typeof Button & {
    (props: ButtonProps & { endIcon?: React.ReactElement }): React.ReactElement;
};
